import { atom, useAtom } from "jotai";

const NotebookReferencePanelAtom = atom<boolean>(false);

const useToggleNotebookReferencePanel = () => {
    const [showPanel, setShowPanel] = useAtom(NotebookReferencePanelAtom);
    const toggleDisplay = () => {
        setShowPanel(!showPanel);
    };

    const closePanel = () => {
        setShowPanel(false);
    };
    return { showPanel, toggleDisplay, closePanel };
};

export default useToggleNotebookReferencePanel;
